// Function to trigger sorting when a sorting option is selected
function applySorting() {
   const selectedOption = document.querySelector('input[name="sort_by"]:checked').value;
   const currentQueryParams = new URLSearchParams(window.location.search);
   currentQueryParams.set('sort_by', encodeURIComponent(selectedOption));
   window.location.search = currentQueryParams.toString();
   showOrHideClearButton();
}

// Function to clear the filter
function clearFilter() {
   const currentQueryParams = new URLSearchParams(window.location.search);
   currentQueryParams.delete('sort_by');
   window.location.search = currentQueryParams.toString();
   showOrHideClearButton();
}

// Function to show or hide the clear filter button based on filter presence
function showOrHideClearButton() {
   const urlParams = new URLSearchParams(window.location.search);
   const filterApplied = urlParams.has('sort_by');
   const clearFilterButton = document.getElementById('clearFilterButton');
   clearFilterButton.style.display = filterApplied ? 'flex' : 'none';
}

// Add event listener to the radio buttons
const radioInputs = document.querySelectorAll('input[name="sort_by"]');
radioInputs.forEach((radio) => {
   radio.addEventListener('change', () => {
       applySorting();
   });
});

// Add event listener to the clear filter button
const clearFilterButton = document.getElementById('clearFilterButton');
clearFilterButton.addEventListener('click', () => {
   clearFilter();
});

// Check query parameter on page load and apply the selected filter
document.addEventListener('DOMContentLoaded', () => {
   const urlParams = new URLSearchParams(window.location.search);
   const selectedOption = urlParams.get('sort_by');
   if (selectedOption) {
       const targetRadio = document.querySelector(`input[name="sort_by"][value="${selectedOption}"]`);
       if (targetRadio) {
           targetRadio.checked = true;
       }
       showOrHideClearButton();
   }
});

// Add event listener to category checkboxes
document.addEventListener("DOMContentLoaded", function() {
   const checkboxes = document.querySelectorAll('input[name="category"]');
   checkboxes.forEach(checkbox => {
       checkbox.addEventListener("click", function() {
           const collectionUrl = this.getAttribute("data-url");
           if (collectionUrl) {
               window.location.href = collectionUrl;
           }
       });
   });
});
